<template>
  <div class="row" v-if="cuser.roles =='superoperator'">
    <div class="col-12">
      <div class="card m-b-30">
        <div class="card-header">
          <h5 class="card-title mb-0">Filtri</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-3">
              <input
                type="text"
                v-model="query"
                class="form-control"
                placeholder="Codice/ragione sociale/telefono/email"
              />
            </div>

            <div class="col-2">
              <select class="form-control" v-model="procedure">
                <option value="">Tutte le procedure</option>
                <option value="procura">Procura</option>
                <option value="tradizionale">Tradizionale</option>
              </select>
            </div>
            <div class="col-2">
              <select
                class="form-control"
                v-model="company"
                v-if="!isInRole('user') && !isInRole('customer')"
              >
                <option value="">Tutte le banche</option>
                <option v-for="c in cuser.companies" :value="c.companyId">
                  {{ c.name }}
                </option>
              </select>
            </div>
               <div class="col-2">
          <select class="form-control" v-model="missingdocumentation">
            <option value="">Tutte</option>
          <option value="true">Documentazione carente</option>
         
          </select>
         </div>
          </div>
  <div class="row mt-2">
           <div class="col-6 ">
            
               <label class="form-label">Data di stipula presunta:</label>
           </div>
           <div class="col-6">
            
               <label class="form-label">Data scadenza contratto:</label>
           </div>
               <div class="col-3">
<input type="date" class="form-control" v-model="stipulationdatestart"/>
          </div>
             <div class="col-3">
<input type="date" class="form-control" v-model="stipulationdateend"/>

           </div>

            
               <div class="col-3">
<input type="date" class="form-control" v-model="expirationdatestart"/>
          </div>
             <div class="col-3">
<input type="date" class="form-control" v-model="expirationdateend"/>

           </div>
  </div>
   <div class="row mt-2">
           <div class="col-6 ">
            
               <label class="form-label">Data di stipula:</label>
           </div>
           <div class="col-6">
            <label class="form-label">Data invio bozza:</label>
               
           </div>
               <div class="col-3">
<input type="date" class="form-control" v-model="releasedatestart"/>
          </div>
             <div class="col-3">
<input type="date" class="form-control" v-model="releasedateend"/>

           </div>

            
              <div class="col-3">
<input type="date" class="form-control" v-model="draftdatestart"/>
          </div>
             <div class="col-3">
<input type="date" class="form-control" v-model="draftdateend"/>

           </div>
  </div>
   <div class="row mt-2">
         <div class="col-2" v-if='isInRole("superoperator") || isInRole("operator")|| isInRole("commercialoperator")'>
          <select
              name="inchargeTo"
              class="form-control"
              v-model="outsourcer"
              
            >
              <option value="">Tutti</option>
              <option value="outsourcer">Solo outsourcer</option>
              <option value="internal">No outsourcer</option>
              
            </select>
       </div>
           
       <div class="col-2" v-if='isInRole("superoperator")'>
          <select
              name="inchargeTo"
              class="form-control"
              v-model="inchargeto"
              
            >
              <option value="">Nessun operatore</option>
              <option
                v-for="option in operators"
                v-bind:key="option.userId"
                v-bind:value="option.userId"
              >
                {{ option.firstName }} {{ option.lastName }}
              </option>
            </select>
       </div>
        </div>
          <div class="row mt-2">
            <div class="col-12 text-right">
              <button class="btn btn-primary-rgba mr-2" v-on:click="loaddata">
                <i class="feather icon-filter mr-2"></i>Filtra
              </button>

              <button class="btn btn-danger-rgba" v-on:click="resetdata">
                <i class="feather icon-delete mr-2"></i>Elimina filtro
              </button>
              <button
                class="btn btn-secondary-rgba ml-2"
                v-if="isInRole('superoperator')"
                v-on:click="exportXlsx"
              >
                <i class="feather icon-file mr-2"></i>Esporta Excel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card m-b-30" v-if="contracts.length > 0">
        <div class="card-body">
          <div class="row">
            <div class="col-6">
               <strong>{{ contracts.length }}</strong> Contratti Selezionati
          <button v-on:click="selectAll"  class="btn btn-small btn-success-rgba ml-3">Seleziona tutti i contratti della pagina</button>
          <button v-on:click="loaddata" class="btn btn-small btn-danger-rgba ml-3">Rimuovi selezione</button>
        </div>
           
              <div class="col-3">
               <input type="date" v-model="date" class="form-control"/>
                </div>
           
              <div class="col-3">
          <button v-on:click="invoice"  class="btn btn-small btn-success-rgba ml-3">Evadi</button>
         
        </div>
            </div>
          </div>
         
      </div>
      <div class="card m-b-30">
        <div class="card-body">
          <table
            ref="table"
            id="list-contract-table"
            class="table table-hover w-100"
          ></table>
        </div>
      </div>
    </div>
    <a ref="exportA"></a>
  </div>
  <!-- /.col -->
</template>
<style>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.1s;
  transition: 0.1s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
<script>
import axios from "axios";


export default {
  computed: {
    cuser() {
      return this.$store.state.user;
    },
  },
  components: {},
  data() {
    return {
      outsourcer: "",
      outsourcers: [],
      tags: [],
      query: "",
      state: "",
      procedure: "",
      company: "",
      inchargeto: "",
      missingdocumentation: "",
      expirationdatestart:null,
      expirationdateend:null,
      stipulationdatestart: null,
      stipulationdateend: null,
      releasedatestart:null,
      releasedateend:null,
      draftdatestart:null,
      draftdateend:null,
      operators: [],
      contracts: [],
      date: null
    };
  },
  name: "ContractFilteredList",
  beforeMount() {
    var me = this;
    window.ViewMessage = function (id) {
      me.$router.push({
        name: "route-message",
        params: { id: id },
        replace: true,
      });

      return false;
    };
  },

  mounted() {
    var me = this;
    global.$(document).on("change", ".slider input", function () {
      setTimeout(me.setContracts, 500);
    });

    me.query = "";

    me.state = this.$route.params.state;

    axios.get("contract/operators").then((response) => {
      this.operators = response.data;
    });

    axios.get("contract/outsourcer").then((response) => {
      this.outsourcers = response.data;
      setTimeout(this.loaddata, 200);
    });
  },
  methods: {
    setContracts: function (id) {
      var isChecked = global.$("#chk-" + id).is(":checked");
      if (isChecked) {
        if (this.contracts.filter((c) => c == id).length == 0) {
          this.contracts.push(id);
        }
      } else {
        this.contracts = this.contracts.filter((c) => c != id);
      }
      // event.tags.toLowerCase().values().includes(this.filterValue.toLowerCase())

      return false;
    },
    selectAll:function(){
      var me = this;
global.$(".contractCheck").each(function() {
this.checked = true;
me.setContracts(this.value);

});


    },
    edit: function (cid, id) {
      this.$router.push({
        name: "route-contract-edit",
        params: { cid: cid, id: id },
      });
      return false;
    },
    resetdata() {
      this.query = "";
      this.tags = [];
      this.stipulationdatestart = this.stipulationdateend = 
      this.expirationdatestart = this.expirationdateend =
      this.releasedatestart = this.releasedateend =
      this.draftdatestart = this.draftdateend =
      null;
      this.company =
        this.procedure =
        this.operator =
        this.inchargeto =
        this.missingdocumentation =
          "";
      axios.get("contract/outsourcer").then((response) => {
        this.outsourcers = response.data;
        this.loaddata();
      });
    },
    exportXlsx: function () {
      var me = this;
      axios
        .get(`contract/excel`, { responseType: "blob" })
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(
              blob,
              "riscattileasingexport.xlsx"
            );
          } else {
            me.$refs.exportA.href = URL.createObjectURL(blob);
            me.$refs.exportA.download = "riscattileasingexport.xlsx";
            me.$refs.exportA.click();
          }
        });
    },
invoice:function(){

   axios.post("contract/invoice",{
     date : this.date,
      contracts:this.contracts
   }).then((response) => {
      this.loaddata();
    });

},
    isInRole(role) {
      if (this.cuser)
        for (var i = 0; i < this.cuser.roles.length; i++) {
          if (this.cuser.roles[i] == role) {
            return true;
          }
        }
      return false;
    },
    loaddata: function () {
      var me = this;
me.contracts =[];
      window["EditAction"] = this.edit;
      window["SetContract"] = me.setContracts;

      if ($.fn.DataTable.isDataTable("#list-contract-table")) {
        $("#list-contract-table").DataTable().destroy();
      }

      var $table = $("#list-contract-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url: window.SETTINGS.apiUrl + "/contract/list",
          type: "POST",
          data: function (d) {
            d.search.value = me.query;
            d.filters = [
              {
                key: "state",
                value: me.state,
              },
              {
                key: "outsourcer",
                value: me.outsourcer,
              },

              {
                key: "procedure",
                value: me.procedure,
              },
              {
                key: "company",
                value: me.company,
              },
              {
                key: "missingdocumentation",
                value: me.missingdocumentation,
              },
              {
                key: "inchargeto",
                value: me.inchargeto,
              },
               {
             key:"stipulationdate",
             value:me.stipulationdatestart+'|'+me.stipulationdateend
            },
               {
             key:"draftdate",
             value:me.draftdatestart+'|'+me.draftdateend
            },
            {
             key:"expirationdate",
             value:me.expirationdatestart+'|'+me.expirationdateend
            },
             {
             key:"releasedate",
             value:me.releasedatestart+'|'+me.releasedateend
            },
          
            ];

            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "contractId",
            name: "contractId",
            title: "Ragione sociale",
            render: function (data, type, row, meta) {
              var checked = "";
              if (me.contracts.filter((c) => c == data).length > 0) {
                checked = "checked";
              }
             
              var retval = `
              <div class="row">
              <div class="col-1 ${me.state=='16'?'':'d-none'}">
              <label class="switch"  >
  <input class="contractCheck" ${checked} id="chk-${data}" type="checkbox" value="${data}" onClick="window.SetContract('${
                row.contractId
              }')">
  <span class="slider round"></span>
</label>
              </div>
              <div class="col">
               <span class="badge badge-success capitalize ${
                 row.procedureId
               }">${
                row.procedureId
              }</span> <span class="badge badge-info capitalize">${
                row.ransomId
              } ${row.subRansomId || ""}</span>
             <span class="badge  float-right p-0 mr-2"><img class="img-fluid" style="height:25px"  src="assets/images/logo/${
               row.companyId
             }.svg"/></span>
              <span class="badge float-right p-2  mr-2"><strong>${ (me.state =='200' || me.state =='201')? me.$options.filters.formatDate(
                 row.invoiceDate 
                ):''}</strong></span> 
            <span class="badge badge-info float-right p-2  mr-2">${me.$options.filters.contractState(
             (me.state =='200'?'Invoice':me.state =='201'?'NotCompleted':'ToBeInvoiced')
            )}</span> 
            
             <h4>${row.code}</h4>
              <h5>${row.companyName}</h5>
            
             
              `;

              if (me.isInRole("user")) {
                retval += "<p> Valore di riscatto:<strong class='ml-2 mr-2'>";
                retval += me.$options.filters.toCurrency(row.amount);
                retval += "</strong>";
                retval += "Pagamento riscatto:<strong class='ml-2 mr-2'>";
                retval += row.ransomPayment ? "SI" : "NO";
                retval += "</strong>";

                retval += "</p>";
              }
              retval += "<p>";
                if(row.expirationDate){
               retval+=`<strong title="Scadenza Contratto"><i class="feather icon-alert-triangle mr-2"></i>${me.$options.filters.formatDate(row.expirationDate)}</strong><br/>`
              }
              if(row.releaseDate){
               retval+=`<strong title="Data Stipula"><i class="feather icon-calendar mr-2"></i>${me.$options.filters.formatDate(row.releaseDate)}</strong><br/>`
              }
              if (row.operator) {
                retval += `<span class="text-muted mr-2"><i class="feather icon-user mr-2"></i>${row.operator.firstName} ${row.operator.lastName}</span>`;
              }
              if (row.outSourcerId) {
                var outsourcer = me.outsourcers.filter(
                  (x) => x.userId == row.outSourcerId
                );

                if (outsourcer.length > 0) {
                  retval += `<span class="text-muted"><i class="feather icon-user mr-2"></i>${outsourcer[0].firstName} ${outsourcer[0].lastName}</span>`;
                }
              }
              retval += "</p>";
              if (row.emailToProcess > 0) {
                retval += `<strong><i class="feather icon-mail mr-2"></i>${
                  row.emailToProcess
                }
              <i class="feather icon-calendar ml-2 mr-2"></i>${me.$options.filters.formatDate(
                row.lastEmailToProcess
              )}</strong>`;
              }

              if (row.missingDocumentation) {
                retval += `<strong class="ml-5 text-danger"><i class="fa fa-file-pdf-o mr-2"></i>DOCUMENTAZIONE CARENTE</strong>`;
              }
              retval += "</div></div>";

              return retval;
            },
          },
          {
            className: "text-right",
            data: "contractId",
            name: "contractId",
            title: "Azioni",
            render: function (data, type, row, meta) {
              return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.EditAction('${row.companyId}','${row.contractId}')"><i class="feather icon-edit-2"></i></button>
                                    <button type="button" class="btn btn-danger-rgba remove-action d-none"  data-id="${data}"><i class="feather icon-trash"></button></div>`;
            },
          },
        ],

        createdRow: function (row, data, dataIndex) {
          // Set the data-status attribute, and add a class
          $(row).addClass("importance importance-" + data.importance);
        },
      });
    },
  },
};
</script>
